import * as deliveryApi from '~/api/delivery';
import * as userSelectors from '../selector/userSelectors.js';
import { extract } from '../../../utils/jsonApi.js';
import { SERVICE_TYPE } from '~/constant.js';

const BASE = 'delivery :';

export const deliveryActionTypes = {
  searchRestaurantsStart: `${BASE} restaurants : search start`,
  searchRestaurantsSuccess: `${BASE} restaurants : search SUCCESS`,
  searchRestaurantsFailed: `${BASE} restaurants : search FAILED`,

  fetchDeliveryGroupsStart: `${BASE} delivery groups : fetch start`,
  fetchDeliveryGroupsSuccess: `${BASE} delivery groups : fetch SUCCESS`,
  fetchDeliveryGroupsFailed: `${BASE} delivery groups : fetch FAILED`,

  searchOnTermStart: `${BASE} search on term : fetch start`,
  searchOnTermSuccess: `${BASE} search on term : fetch SUCCESS`,
  searchOnTermFailed: `${BASE} search on term : fetch FAILED`,

  searchRestaurantsByAddressStringStart: `${BASE} restaurants by address : search start`,
  searchRestaurantsByAddressStringSuccess: `${BASE} restaurants by address : search SUCCESS`,
  searchRestaurantsByAddressStringFailed: `${BASE} restaurants by address : search FAILED`,

  fetchRestaurantCollectionStart: `${BASE} restaurant collection : fetch start`,
  fetchRestaurantCollectionSuccess: `${BASE} restaurant collection : fetch SUCCESS`,
  fetchRestaurantCollectionFailed: `${BASE} restaurant collection : fetch FAILED`,
};

export const searchUrlAddress = (address, googleMaps) => async (dispatch) => {
  dispatch({
    type: deliveryActionTypes.searchRestaurantsByAddressStringStart,
  });
  try {
    const query = { address };
    const { geometry } = await googleMaps.getGeoLocation(query);
    if (geometry) {
      const { location } = geometry;
      const geoLocation = { lat: location.lat(), lng: location.lng() };
      const [deliveryGroupJson, restaurantCollection] = await Promise.all([
        deliveryApi.searchRestaurants({ geoLocation }),
        deliveryApi.getRestaurantCollection(),
      ]);

      const deliveryGroups = extract(deliveryGroupJson, 'deliveryGroup') || [];
      dispatch({
        type: deliveryActionTypes.searchRestaurantsByAddressStringSuccess,
        deliveryGroups,
        restaurantCollection: restaurantCollection.data,
        searchOnly: true,
      });
    }
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('what is wrong??? ', e, address);
    dispatch({
      type: deliveryActionTypes.searchRestaurantsByAddressStringFailed,
      searchOnly: true,
    });
  }
};

export const searchRestaurants = () => async (dispatch, getState) => {
  const { geoLocation, addressId } = userSelectors.selectUserAddress(getState());
  dispatch({
    type: deliveryActionTypes.searchRestaurantsStart,
  });
  try {
    const [deliveryGroupJson, restaurantCollection] = await Promise.all([
      deliveryApi.searchRestaurants({ addressId, geoLocation }),
      deliveryApi.getRestaurantCollection(),
    ]);
    let { meta: { delivery_zone_blacked_out } } = deliveryGroupJson;
    const deliveryGroups = extract(deliveryGroupJson, 'deliveryGroup') || [];
    const _deliveryGroups_ = deliveryGroups.map((deliveryGroup) => {
      return Object.assign({}, deliveryGroup, {
        // delivery_zone_blacked_out: !!delivery_zone_blacked_out,
        relationships: Object.assign({}, deliveryGroup.relationships || {}, {
          restaurants: Object.assign({}, deliveryGroup.relationships?.restaurants || {}, {
            data: (deliveryGroup.relationships?.restaurants?.data || []).map((restaurant) => {
              return Object.assign({}, restaurant, {
                attributes: Object.assign({}, restaurant.attributes, {
                  deliveryZoneBlackedOut: !!delivery_zone_blacked_out
                })
              })
            })
          })
        }),
      })
    });
    dispatch({
      type: deliveryActionTypes.searchRestaurantsSuccess,
      deliveryGroups: _deliveryGroups_,
      restaurantCollection: restaurantCollection.data,
    });
  } catch (e) {
    dispatch({
      type: deliveryActionTypes.searchRestaurantsFailed,
    });
  }
};

export const fetchDeliveryGroups = () => async (dispatch, getState) => {
  const state = getState();
  const { geoLocation, addressId } = userSelectors.selectUserAddress(state);
  const serviceType = userSelectors.selectUserServiceType(state);
  if (!geoLocation && !addressId) {
    return;
  }
  if (serviceType !== SERVICE_TYPE.DELIVERY) {
    dispatch({
      type: `fetchDeliveryGroups - service type is ${serviceType} - skipping`,
    });
    return;
  }
  dispatch({
    type: deliveryActionTypes.fetchDeliveryGroupsStart,
  });
  try {
    const deliveryGroupJson = await deliveryApi.searchRestaurants({ addressId, geoLocation });
    const deliveryGroups = extract(deliveryGroupJson, 'deliveryGroup') || [];
    dispatch({
      type: deliveryActionTypes.fetchDeliveryGroupsSuccess,
      deliveryGroups,
    });
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(e);
    dispatch({
      type: deliveryActionTypes.fetchDeliveryGroupsFailed,
    });
  }
};

export const searchOnTerm = ({ term, addressId, geoLocation }) => async (dispatch) => {
  dispatch({
    type: deliveryActionTypes.searchOnTermStart,
  });
  try {
    const data = await deliveryApi.getSearchOnTerm({ term, addressId, geoLocation });
    const meals = extract(data, 'mealInstance') || [];
    dispatch({
      type: deliveryActionTypes.searchOnTermSuccess,
      suggestedMeals: meals,
    });
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('failed... ', e);
    dispatch({
      type: deliveryActionTypes.searchOnTermFailed,
    });
  }
};
